module.exports = __webpack_public_path__ + "media/images/redeem-code-72d71454.svg";